'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import Icon from '@/components/ui/AppIcon';

const MarketChart = dynamic(() => import('@/app/components/MarketChart'), { ssr: false });

const marketStats = [
  { label: 'Dubai Avg Price/sqft', value: 'AED 1,842', change: '+8.4%', positive: true },
  { label: 'Transactions (May 2026)', value: '14,280', change: '+12.1%', positive: true },
  { label: 'Off-Plan Share', value: '61%', change: '+5.2%', positive: true },
  { label: 'Avg Rental Yield UAE', value: '6.8%', change: '-0.3%', positive: false },
];

export default function MarketInsights() {
  return (
    <section className="py-20 bg-muted/40">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-accent text-sm font-semibold uppercase tracking-widest mb-2">Live Data</p>
            <h2 className="section-title text-3xl">Market Insights</h2>
            <p className="section-subtitle">UAE real estate market performance — updated daily</p>
          </div>
          <div className="hidden md:flex items-center gap-2 text-muted-foreground text-xs">
            <Icon name="ClockIcon" size={14} />
            Last updated: 07 Jun 2026, 10:30 AM GST
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 xl:grid-cols-4 2xl:grid-cols-4 gap-4 mb-8">
          {marketStats?.map((stat) => (
            <div key={`market-stat-${stat?.label}`} className="bg-card rounded-2xl p-5 border border-border shadow-card">
              <div className="stat-label mb-2">{stat?.label}</div>
              <div className="stat-value text-2xl mb-1">{stat?.value}</div>
              <div className={`flex items-center gap-1 text-sm font-semibold ${stat?.positive ? 'text-emerald-600' : 'text-red-500'}`}>
                <Icon name={stat?.positive ? 'ArrowTrendingUpIcon' : 'ArrowTrendingDownIcon'} size={14} />
                {stat?.change} vs last month
              </div>
            </div>
          ))}
        </div>

        {/* Chart */}
        <div className="bg-card rounded-2xl border border-border shadow-card p-6">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h3 className="font-bold text-foreground text-base">Dubai Property Price Index — 2025/2026</h3>
              <p className="text-muted-foreground text-sm mt-0.5">Average price per sqft across key communities</p>
            </div>
            <div className="flex items-center gap-4 text-xs">
              <div className="flex items-center gap-1.5">
                <div className="w-3 h-3 rounded-full bg-primary" />
                <span className="text-muted-foreground">Avg Sale Price</span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-3 h-3 rounded-full bg-accent" />
                <span className="text-muted-foreground">Rental Yield</span>
              </div>
            </div>
          </div>
          <MarketChart />
        </div>
      </div>
    </section>
  );
}